var _circle, _circle2, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgIllustrationEtablissement = function SvgIllustrationEtablissement(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 120",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 81.8,
    cy: 84.7,
    r: 18.5,
    fill: "var(--color-alert-lighten)",
    transform: "rotate(-90 81.8 84.7)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 35.9,
    r: 18.5,
    fill: "var(--color-alert-lighten)",
    transform: "rotate(-90 38 35.9)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-alert-lighten)",
    d: "m89.4 41.3 1.5-12.5 12.5 1.5-1.5 12.5zM16.7 92.5l2.8-12.3L31.8 83 29 95.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-alert)",
    d: "M61 32.2c-16.2 0-29.5 13-29.5 29C31.5 77 44.8 90 61 90s29.5-13 29.5-28.9c0-16-13.3-28.9-29.5-28.9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-white)",
    d: "M68.3 59.8v-7.7c0-1.4-1.2-2.6-2.6-2.6H58a2.6 2.6 0 0 0-2.6 2.6v2.6H53a2.6 2.6 0 0 0-2.6 2.6V70c0 1.4 1.1 2.6 2.6 2.6h6.4c.7 0 1.3-.6 1.3-1.3v-3.8H63v3.8c0 .7.6 1.3 1.3 1.3H71c1.4 0 2.5-1.2 2.5-2.6v-7.7c0-1.4-1.1-2.6-2.5-2.6h-2.6ZM55.4 70.1H53v-2.5h2.5V70Zm0-5.1H53v-2.6h2.5V65Zm0-5.2H53v-2.5h2.5v2.5Zm5.2 5.2H58v-2.6h2.6zm0-5.2H58v-2.5h2.6zm0-5.1H58V52h2.6v2.6ZM65.7 65h-2.6v-2.6h2.6zm0-5.2h-2.6v-2.5h2.6zm0-5.1h-2.6V52h2.6v2.6ZM71 70h-2.6v-2.5H71zm0-5.1h-2.6v-2.6H71V65Z"
  })));
};
export default SvgIllustrationEtablissement;